import * as React from 'react'
import { RenderLeafProps } from 'slate-react'

const Bold = ({
  children,
  ...attributes
}: RenderLeafProps['attributes'] & RenderLeafProps['children']) => (
  <b {...attributes}>{children}</b>
)

export default Bold
